import{useRef as r}from"react";import{generateNameHash as t}from"../shared/helpers.js";const u=(n,o)=>{const e=r(o??t(n)),m=r(`${e.current}-${t()}`);return{name:e.current,id:m.current}};export{u as useNameAndId};
